// Componente de proteção de rota para usuários do tipo Empresa
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useCurrentUser } from '../contexts/UserContext';
import { useAuth } from '../hooks/useAuth';

interface CompanyOnlyRouteProps {
  children: React.ReactNode;
}

const CompanyOnlyRoute: React.FC<CompanyOnlyRouteProps> = ({ children }) => {
  const { currentUser, loading } = useCurrentUser();
  const { isTokenValid } = useAuth();

  // Se não há token válido, redirecionar para login
  if (!isTokenValid()) {
    return <Navigate to="/login" replace />;
  }

  // Mostrar loading enquanto carrega informações do usuário
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '16px'
      }}>
        Carregando...
      </div>
    );
  }

  // Se terminou de carregar mas não há usuário, houve erro de autenticação
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // Verificar se usuário é do tipo Usuário está tentando acessar rotas de empresa ou admin.
  if (currentUser.tipo === 0) {
    // Usuário logado mas não é empresa, redirecionar para home
    return <Navigate to="/home" replace />;
  }

  // Usuário autorizado - renderizar filhos
  return <>{children}</>;
};

export default CompanyOnlyRoute;